import React from 'react';
import LogoCRS from '../img/logo-CRS.svg';
import LogosDipu from '../img/logo-las-dehesas-dipu.svg';

const Footer = () => (
  <div className="footer">
    <img src={LogoCRS} alt="Miel las dehesas" className="footer__crs" />
    <img
      src={LogosDipu}
      alt="Miel las dehesas logo dipu"
      className="footer__dipu"
    />
  </div>
);

export default Footer;
